export const info = {
  firstName: 'Aarav',
  lastName: 'Kansupada',
  initials: 'AK',
  tagline: 'Professional Dabbler',
  lastUpdated: 'September 25, 2026',

  quote: {
    text: "Don't ask yourself what the world needs. Ask yourself what makes you come alive, and go do that, because what the world needs is people who have come alive.",
    author: 'Howard Thurman',
  },

  // Supports inline markdown: **bold**, *italic*, `code`, [text](url).
  intro:
    "[CS + Business Honors](https://csb.utexas.edu/) at UT Austin. Here's me in a few bullet points.",

  miniBio: [
    'Born and raised in Dallas, TX',
    'Interested in tech, venture, & finance',
    'Background working at startups',
    'Product-oriented. Want to build things people use',
  ],

  socials: [
    {
      link: 'https://github.com/ArcKansupada',
      label: 'Github',
    },
    {
      link: 'https://www.linkedin.com/in/aaravkansupada/',
      label: 'LinkedIn',
    },
    {
      link: 'mailto:aaravk@utexas.edu',
      label: 'Email',
    },
    {
      link: 'https://x.com/aaravkansupada',
      label: 'X',
    },
  ],

  // About page copy. Each string is its own paragraph — add as many as you like.
  about: [
    "Hi there.",
    'I spend most of my time somewhere between building things, reading about the business of building things, and thinking while pacing around my room. The rest goes to friends, F1, movies, and flying my drone.',
    'At UT, I am involved with [Texas Venture Group](https://www.texasventuregroup.com/) and the [Texas Undergraduate Investment Team](https://www.texasuit.com/).',
  ],

  // Favorite movies, shown on the About page.
  // `note` is optional — leave it off for a bare title, add it for a one-line take.
  favoriteMovies: [
    { title: 'The Dark Knight', year: 2008 },
    { title: 'Casino Royale', year: 2006 },
    { title: 'Gladiator', year: 2000 },
    { title: 'Heat', year: 1995 },
    { title: 'GoodFellas', year: 1990 },
  ],

  // Teams, shown on the About page beside the movies.
  // `league` and `note` are both optional.
  // TODO: these are placeholders — replace with the teams you actually support.
  teams: [
    { name: 'Texas Longhorns' },
    { name: 'Real Madrid'},
    { name: 'Ferrari', league: 'F1' },
    { name: 'Dallas Cowboys' },
    { name: 'Dallas Mavericks' },
    
  ],

  hobbies: [
    { label: 'Movies' },
    { label: 'Drones' },
    { label: 'Traveling' },
    { label: 'Catan' },
    { label: 'Writing' },
    { label: 'Formula 1' },
    { label: 'European Soccer' },
    { label: 'Biking' },
    { label: 'RTS Games' },
    { label: 'Mechanical Keyboards' },
  ],

  experience: [
    {
      title: 'Software Engineering Intern',
      company: 'Apptronik',
      link: 'https://apptronik.com/',
      date: 'May 2026 - Aug 2026',
      description: 'Humanoids',
    },
    {
      title: 'Software Engineering Intern',
      company: 'Boundary',
      link: 'https://boundaryml.com/',
      date: 'Feb 2026 - Apr 2026',
      description: 'BAML SDKs',
    },
    {
      title: 'Co-Developer',
      company: 'OurGarden',
      link: 'https://www.congressionalappchallenge.us/23-tx30/',
      date: 'Jun 2023 - Oct 2025',
      description: 'Plants',
    },
    {
      title: 'Software Engineering Intern',
      company: 'Fynopsis.ai',
      date: 'Jun 2025 - Aug 2025',
      description: 'AI Datarooms',
    },
    {
      title: 'Software Engineering Intern',
      company: 'Colorado School of Mines',
      date: 'Jun 2024 - Aug 2024',
      description: 'Computing4Good',
    },
    {
      title: 'Machine Learning Intern',
      company: 'StARLinG Lab',
      link: 'https://starling-lab.github.io/',
      date: 'Jun 2023 - Jul 2023',
      description: 'Soccer ML',
    },
  ],
};
